import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  subUnits: null,
  loading: false,
  total: 0,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, savedSearches } = payload;
  const subUnits = data;

  return {
    ...state,
    subUnits,
    total,
    filteredTotal,
    filters,
    savedSearches,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
